module.exports = __webpack_public_path__ + "img/ic-qr-without-amount.svg";